export const iosDeviceIds = {
    ipadSpain: 'bea752e4-8847-4ed9-8853-82bd27e0bc58',
    iPhoneSpain: 'b88d9586-dcb7-4218-848c-94f9d518961d',
};
